(function () {
  const tickerItems = Array.from(document.querySelectorAll('.ticker__item'));
  let active = 0;
  let isPlaying = true;
  let prev = tickerItems.length - 1;
  const activeClass = 'ticker__item--active';
  const leaveClass = 'ticker__item--leaving';
  const initTicker = () => {
    if (isPlaying) {
      if (active === tickerItems.length - 1) {
        active = 0;
        prev = tickerItems.length - 1;
      } else {
        active++;
        prev = active - 1;
      }
      tickerItems[prev].classList.remove(activeClass);
      tickerItems[prev].classList.add(leaveClass);
      tickerItems[active].classList.remove(leaveClass);
      tickerItems[active].classList.add(activeClass);
    }
  };

  // add active class to first ticker item if it exists
  if (tickerItems.length) {
    tickerItems[0].classList.add(activeClass);
  }

  // ... and change active ticker item every 4 sec if there is more than one item
  if (tickerItems.length > 1) {
    setInterval(initTicker, 4000);
  }

  try {
    // Pause ticker when invisible
    const tickerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          isPlaying = true;
          return;
        }

        isPlaying = false;
      });
    });
    tickerObserver.observe(document.querySelector('.ticker'));
  } catch (e) {
    // some old browsers are incompatible with IntersectionObserver
    // In this case the ticker will not stop
    return e;
  }
})();
